'use strict';

var v = 'v0.30';
var sideScrollerDebugrMode = false;


$.extend($.easing, {
    easeOutExpo: function (x, t, b, c, d) {
        return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    },
    easeInOutExpo: function (x, t, b, c, d) {
      if (t==0) return b;
      if (t==d) return b+c;
      if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
      return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
	  },
    easeOutCirc: function(t, b, c, d) {
      return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
    }
});


var lastReportedSlug = null;
var activeSlug = null;

//Obiekt zbierający informacje o elementach typu banner, slider, before/after, których statystyki należy wysłać w unload
var statElementCollector = new Object();
var ga360statElementsInit = function(el) {
    alert( $(el).data('ga360-id') );
};

var slidePositionVieved = new Object();

function ga360Test(){

    var statElementArray = [];
    
    for (var pos in statElementCollector) {
        statElementArray.push(statElementCollector[pos]);
    };

    console.log(statElementArray);

}
var viewData = [];

/**
 * sideScroller v0.2
 * @author Blanka
 *
 * użycie: new _SideScroller(string|sectionsSelector):object
 *  
 **/
class _SideScroller {
  constructor(selector, parameters) {
    //# PRIVATE
    this.data = [];
    this.position = 0;
    this._scrollDest = 0;
    this.scrollStep = GSAP_horizontal?Math.round(window.innerWidth / 2) : Math.round(window.innerHeight / 1.5);
    this.width = 0;
    this.buttonNext = document.querySelector('.section--button-right');
    this.buttonPrev = document.querySelector('.section--button-left');
    this._scrollLastPos = 0;
    this.scrollDirection = 1; //1: forward, 0: backward
    this.scrollFIvl = -1;
    this.scrollBIvl = -1;
    this._statIterationType = 'unknown';
    this._dubugerMode = Boolean(parameters&&parameters.debugger==true);
    
    //scroll forward
    this.buttonNext.addEventListener('mousedown', event => {
      this._statIterationType = 'button';
      this.scrollForward();
      this.scrollFIvl = setInterval(()=>{
        this.scrollForward();
      }, 300);
      event.preventDefault();
    });
    this.buttonNext.addEventListener('mouseup', event => {
      this._clearScrollFIvl();
    });
    this._clearScrollFIvl = function(){
      if (this.scrollFIvl>-1) clearInterval(this.scrollFIvl);
      this.scrollFIvl = -1;
    };

    //scroll backforward
    this.buttonPrev.addEventListener('mousedown', event => {
      this._statIterationType = 'button';
      this.scrollBackward();
      this.scrollBIvl = setInterval(()=>{
        this.scrollBackward();
      }, 300);
      event.preventDefault();
    });
    this.buttonPrev.addEventListener('mouseup', event => {
      this._clearScrollBIvl();
    });
    this._clearScrollBIvl = function(){
      if (this.scrollBIvl>-1) clearInterval(this.scrollBIvl);
      this.scrollBIvl = -1;
    };
    
    //sprawdzanie aktualnej sekcji
    window.setInterval(()=>{
      var scroll = GSAP_horizontal ? window.scrollX : window.scrollY;
      this.scrollDirection = (function(a, b, c){
        if (a<b) return 1; 
        if (a>b) return 0;
        return c;
      })(this._scrollLastPos, scroll, this.scrollDirection);
      this._scrollLastPos = scroll;
      this.position = this._calcPosition(scroll);
      //slugi
      var slug = this.data[this.position].slug;
      if (activeSlug!=slug) {
        //slug się zmienia
        history.pushState({
          id: slug
        }, slug, slug + ((document.location.search.length>-1)? document.location.search:'') );
        activeSlug = slug;
        this.reportSlug();
      }
      if (this._dubugerMode) this._debuggerShow();
    }, 250);
    
    //init
    window.addEventListener('DOMContentLoaded', () => {
      var sum_width = 0;
      document.querySelectorAll(selector).forEach(element => {
        this.data.push({
          width : (isLandscape ? element.offsetWidth : element.offsetHeight),
          start: sum_width,
          end: (isLandscape ? element.offsetWidth : element.offsetHeight) + sum_width,     
          slug: element.dataset.slug
        });
        sum_width += (isLandscape ? element.offsetWidth : element.offsetHeight)-1;
      });
      this.width = sum_width;
    });

    document.addEventListener('keydown', (event) => {
      var key = event.which;
      if (key == 39) {     
        this._statIterationType = 'keyboard';
        this.scrollForward();
      } else if (key == 37) {
        this._statIterationType = 'keyboard';
        this.scrollBackward();
      }
    });
  }
  _calcPosition(scroll){
    var s = 0;
    while ( this.data[s].start + this.data[s].width < scroll) {
      s++;
      if (s>=this.data.length-1) break;
    }
    if (scroll<Math.floor(window.innerWidth/10)) {
      this.buttonPrev.classList.add('__jsHidden');
      this._clearScrollBIvl();
    } else this.buttonPrev.classList.remove('__jsHidden');
    
    if (s==this.data.length-1) {
      this.buttonNext.classList.add('__jsHidden');
      this._clearScrollFIvl();
    } else this.buttonNext.classList.remove('__jsHidden');
    //console.log('Pos: '+this.position + ', s: '+s + ' of '+(this.data.length-1));
    return s;
  }
  
  //# PUBLIC
  to(index){
    if (index<0) index = 0;
    if (index>this.data||index=='last') index = this.data.length-1;
    if (GSAP_horizontal)
      gsap.to(window, {duration: 1, scrollTo: {x: this.data[index].start, autoKill: true }});
    else
      gsap.to(window, {duration: 1, scrollTo: {y: this.data[index].start, autoKill: true }});
  } 
  next(){
    this.to(this.position+1);
  }
  prev(){
    this.to(this.position-1);
  }
  scrollForward(){
    this._scrollDest = GSAP_horizontal ? window.scrollX : window.scrollY;
    this._scrollDest += this.scrollStep;
    this.scrollTo(this._scrollDest);    
    statAction(this._statIterationType, 'navigation');
  }
  scrollBackward(){
    this._scrollDest = GSAP_horizontal ? window.scrollX : window.scrollY;
    this._scrollDest -= this.scrollStep;
    this.scrollTo(this._scrollDest);
    statAction(this._statIterationType, 'navigation');
  }
  scrollTo(position){
    if (position<0) position = 0;
    if (position>this.data[this.data.length-1].end) position = this.data[this.data.length-1].end;
    if (GSAP_horizontal)
      gsap.to(window, {duration: 1, scrollTo: {x: position, autoKill: false }});
    else
      gsap.to(window, {duration: 1, scrollTo: {y: position, autoKill: false }});
  }
  getSectionData(){
    return this.data;
  }
  getActiveSection(){
    return this.position;
  }
  reportSlug(){

    if (lastReportedSlug === null) {
                
          //wyślij statystykę pageview standard
          //wp_dot_addparams.ctags = statData[activeSlug].tags;
          sendStats('pageview', 'scrollboost', activeSlug); 
          try {
            WP.push(() => {
              WP.pwp.viewPage({
                  "ga": { "event": "pageview", "page": {"pageviewType": "standard", "error404": basicStatData.ga.page.error404, "templateType": "AS"},
                  "site": {
                      "name": basicStatData.ga.site.name,
                      "version": basicStatData.ga.site.version,
                      "cms": basicStatData.ga.site.cms,
                      "as": {"orderId": asorderid, "productName": asproduct, "name": asname}
                  },
                  "content": {
                    "title": statData[activeSlug].title,
                    "category" : {
                        IAB: statData[activeSlug].category.IAB,
                        Gemius: statData[activeSlug].category.Gemius
                    },
                    "tags": 'abc'//statData[activeSlug].tags
                }
              }});
            });
          }
          catch(e) { console.log('WP.pwp error: ' + e); }
      
      } else {
          // wyślij statystykę pageview scrolboost vpv. pageviewType ma wartość "overlay" 
          // gdy nie mamy doładowania i "scrollboost" gdy następuje doładowanie, ALE dla pseudo dynamicznych stron AS ma byc jednak scrollboost ;) - ustalone z Salestube !

          //wp_content_selector = document.getElementById(lastReportedSlug);

          try {
            WP.push(() => {
              WP.stat.show(wp_sn, {"category": 'pageviewVpv', "label": 'scrollboost', "asproduct": asproduct, "asorderid": asorderid, "asname": asname }, 'pageviewVpv');
            });
          }
          catch(e) { console.log('WP.statshow error: ' + e); }
          sendStats('pageviewVpv', 'scrollboost', activeSlug); // musi isć dot ptrzed ustawieniem wp_content_selector

          //unloadData(lastReportedSlug);
          //wp_dot_addparams.ctags = statData[activeSlug].tags;
          //console.log('pv');
          try {
              WP.push(() => {
                WP.pwp.viewPage({
                  "ga": { 
                      "event": "pageviewVpv", "page": {"pageviewType": "scrollboost", "error404": basicStatData.ga.page.error404, "templateType": "AS"},
                      "site": {
                          "name": basicStatData.ga.site.name,
                          "version": basicStatData.ga.site.version,
                          "cms": basicStatData.ga.site.cms,
                          "as": {"orderId": asorderid, "productName": asproduct, "name": asname},
                          "frontendPlatform": "other"
                      },
                      "content": {
                          "title": statData[activeSlug].title,
                          "category" : {
                              IAB: statData[activeSlug].category.IAB,
                              Gemius: statData[activeSlug].category.Gemius
                          },
                          "tags": statData[activeSlug].tags
                      }
                      //"content": statData[activeSlug]
                  }
                });
              });
          }
          catch(e) { console.log('WP.pwp.error: ' + e); }
      }

      lastReportedSlug = activeSlug;

   }
   _debuggerShow() {    
      //debugging
      if (!this._debuggerBox){
        this._debuggerBox = document.createElement('div');
        this._debuggerBox.style.cssText = "position:fixed;right:4vw; top:4vw; background:rgba(20,30,40,.7);padding:5px;color:#fff;font-size:11px;z-index:999999;font-family:Courier";
        document.body.appendChild(this._debuggerBox);

        this.dxc = document.createElement('div');
        this.dxc.style.cssText = "position:fixed; top:0; left:0px; z-index:999999; width:10000px; height:20px; font-size: 14px;";
        for (var i=0; i<this.data.length; i++) {
          var dx = document.createElement('div'); 
          dx.style.cssText = "position:absolute;top:0;height: 20px; color:#fff;width:"+(this.data[i].width-12)+"px;left:"+this.data[i].start+"px;background:rgb(4 17 44 / 55%);border-left:1px solid red; padding-left: 10px";
          dx.innerHTML = this.data[i].slug+" - "+this.data[i].start;
          this.dxc.appendChild(dx);
        }
        document.body.appendChild(this.dxc);
        console.log(this.data);
        
      }
      this.dxc.style.marginLeft = -this._scrollLastPos + "px";
      var t = "DEBUGGER<br>\n";
      t += "GSAP_horizontal: " + GSAP_horizontal + "<br>\n";
      t += "isLandscape: " + isLandscape + "<br>\n";
      t += "scrollPos: " + this._scrollLastPos + "<br>\n";
      t += "position: " + this.position + "<br>\n";

      this._debuggerBox.innerHTML = t;
    }
}

var sideScroller = new _SideScroller('section.section', {debugger: sideScrollerDebugrMode});

// flaga dla urządzeń z touch:
if ('ontouchstart' in document.documentElement) {
  var deviceTouch = true;
}

// flaga dla scrollowania:
var isScrolligFlag = false;
var idTS;

window.addEventListener('scroll', function(){
	isScrolligFlag = true;
  if (idTS) {
    clearTimeout(idTS);
  }
  idTS = setTimeout(function(){
  	idTS = null;
  	isScrolligFlag = false;
  }, 450);
});


var DCMimgDot = new Image(0,0);
DCMimgDot.src = 'https://ad.doubleclick.net/ddm/trackimp/N841811.3641246AWARENESS_DISPLAY/B25980123.306536874;dc_trk_aid=499412556;dc_trk_cid=152059722;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=?';

var EXTimgDot = new Image(0,0);
EXTimgDot.src = 'https://m.exactag.com/ai.aspx?tc=5cb672dd2729e339f918ee77b384e539';

$('a, .section--button-right, section--button-left').on('click', function(){
  var CLCimgDot = new Image(0,0);
  CLCimgDot.src = 'https://m.exactag.com/cl.aspx?tc=5cb672dd2729e339f918ee77b384e539&url=https://ad.doubleclick.net/ddm/trackclk/N841811.3641246AWARENESS_DISPLAY/B25980123.306536874;dc_trk_aid=499412556;dc_trk_cid=152059722;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=';  
});



$('.columns--btn').bind('click', function(){    
  WP.push(() => {
    WP.pwp.customAction({"ga": {"event": "site_interaction","eventCategory": 'customer_link', "moduleName": 'dowiedz się więcej' ,"eventAction": deviceTouch?"touch":"click"}});
    sendStats('customer_link', 'click', 'dowiedz się więcej');
  });
});
